<!--
 * @Author: 李朋飞
 * @Date: 2022-07-12 09:10:24
 * @LastEditTime: 2024-05-07 11:37:29
 * @Description: 只展示评分组件 非说原始的不好用...
-->
<template>
  <div class="l_Score">
    <div class="l_Score_item" v-for="(item, index) in max" :key="index">
      <img class="l_Score_item_A" src="../../assets/image/star.png" alt="">
      <div class="l_Score_item_bga"></div>
      <div class="l_Score_item_bgb" :style="itemStyle(index)"></div>
    </div>
    <div class="l_Score_itemB" v-if="showNumber">{{score}}</div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    showNumber: {
      type: Boolean,
      default: true,
    },
    max: { // 星星的最大数量
      type: [String,Number],
      default: 5
    },
    score: { // 评分数
      type: [String,Number],
      default: 0
    }
  },
  data() {
    return{

    }
  },
  methods: {
    itemStyle(index) {
      let showIndex = (this.score / 1)^0; // 显示几个整星
      let showIndexB = this.score % 1 // 显示半星
      let width = '';
      if(index + 1 <= showIndex) {
        width = '100%';
      };
      if(showIndexB > 0 && index+1 == showIndex+1) {
        width = (showIndexB*100) + '%';
      }
      return {
        width
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.l_Score{
  height: 14px;
  display: flex;
  align-items: center;
  .l_Score_item{
    width: 14px;
    height: 14px;
    margin-right: 5px;
    position: relative;
    .l_Score_item_A{
      display: block;
      width: 14px;
      height: 14px;
      z-index: 10;
      position: absolute;
      top: 0;
      left: 0;
    }
    .l_Score_item_bga{
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgb(239, 242, 247);
    }
    .l_Score_item_bgb{
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      z-index: 5;
      background-color: rgb(247, 186, 42);;
    }
  }
  .l_Score_itemB{
    font-size: 14px;
    color: rgb(255, 153, 0);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Score/Score.vue